import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import ExamSubjectAppendReadOnly from "./ExamSubjectAppendReadOnly";
import { useFormik, FieldArray } from "formik";
import * as Yup from "yup";
import Link from "react-router-dom";
import ExamCentersReadOnly from "./ExamCentersReadOnly";
import StudentDateBirthReadOnly from "./StudentDateBirthReadOnly";
import {
  submitExamRegistration,
  getSubmitedExamRegistration,
} from "./../../services/ExamService";
import Swal from "sweetalert2";
import { StandardErrorMessage, Heading3, Heading5, LabelMedium } from "../common/GlobalElements/Typography";
import { tokens } from "../../public/tokens";
import { ContainerWrapper } from "../common/GlobalElements/Wrappers";
import { StandardButton } from "../common/GlobalElements/StandardButton";

const ExamRightBox = (props) => {
  const user = useSelector((state) => state.user);

  const [rsaId, setRsaId] = useState(false);
  const [passport, setPassport] = useState(false);
  const [examId, setExamId] = useState(false);
  const [examStudentReg, setExamStudentReg] = useState([]);
  const [subjectList, setSubjectList] = useState([]);
  const [firstList, setFirstList] = useState([]);
  const [examCenterId, setExamCenterId] = useState();

  let subjects = [];
  let firsts = [];

  const { examid, examListsRow } = props;
  const handleStudentType = (e) => {
    const subjectType = e.target.value;

    if (subjectType === "south-african-citizen") {
      setRsaId(true);
      setPassport(false);
      setExamId(false);
    } else {
      setRsaId(false);
      setPassport(true);
      setExamId(true);
    }
  };

  useState(() => {
    getSubmitedExamRegistration(examid).then((res) => {
      setExamStudentReg(res.data.exam_details[0]);
      setExamCenterId(res.data.exam_details[0].centre);
      if (res.data.exam_details[0].student_type != "south-african-citizen") {
        setExamId(true);
      }

      res.data.examSubjectList.forEach((subject) =>
        subjects.push(subject.subject)
      );
      setSubjectList(subjects);
      res.data.examSubjectList.forEach((first) => firsts.push(first.first));
      setFirstList(firsts);
    });
  }, []);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      exam: examid,
      last_name: examStudentReg.last_name,
      first_name: examStudentReg.first_name,
      second_name: examStudentReg.second_name,
      third_name: examStudentReg.third_name,
      gender: examStudentReg.gender,
      bday_year: examStudentReg.bday_year,
      bday_month: examStudentReg.bday_month,
      bday_day: examStudentReg.bday_day,
      race: examStudentReg.race,
      student_type: examStudentReg.student_type,
      centre: examStudentReg.centre,
      subject_: subjectList,
      first_: firstList,
      rsa_identity: examStudentReg.rsa_identity,
      exam_id_number: examStudentReg.exam_id_number,
      term_condn: true,
      is_exam_id: (examStudentReg?.is_exam_id && examStudentReg?.is_exam_id==1) ? true : false,
    },
    onSubmit: (values) => {
      submitExamRegistration(values).then((res) => {

        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Updated successfully",
        }).then((result) => {
          if (result.value) {
          }
        });
      });
    },
  });

  return (
    <div className="exam-detail-rgt">
      <div className="exam-detail-top d-flex justify-content-between">
        <div className="exam-detail-top-left">
          <div className="exam-bx-info  d-flex">
            <div className="icon">ME</div>
            <div className="exam-bx-info-rgt">
              <Heading3>External Exam Registration Form</Heading3>
              <p>
                Register here for your DoE National Exams. Please ensure that
                you have completed all the required fields
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="exam-register-bx">
        <div className="card card-form-bx">
          <Heading5 marginBottom={tokens.globals["spacing-sm"]}>Application Comments</Heading5>

          <form onSubmit={formik.handleSubmit}>
            <ContainerWrapper>
              <div className="theme-form application-form">
                <div className="row">
                  <div className="form-group col-sm-6">
                    <LabelMedium>Surname as per Your Official ID*</LabelMedium>
                    <input
                      type="hidden"
                      name="exam"
                      value={formik.values.last_name}
                      disabled="disabled"
                    />
                    <input
                      type="text"
                      className={
                        "form-control " +
                        (formik.errors.last_name && formik.touched.last_name
                          ? " is-invalid"
                          : "")
                      }
                      placeholder=""
                      name="last_name"
                      value={formik.values.last_name}
                      disabled="disabled"
                      onBlur={formik.handleBlur}
                    />
                    <StandardErrorMessage formik={formik} name={"last_name"}/>
                  </div>
                  <div className="form-group col-sm-6">
                    <LabelMedium>First Names as per Your Official ID*</LabelMedium>
                    <input
                      type="text"
                      className={
                        "form-control " +
                        (formik.touched.first_name && formik.errors.first_name
                          ? " is-invalid"
                          : "")
                      }
                      placeholder="First Name"
                      value={formik.values.first_name}
                      onBlur={formik.handleBlur}
                      name="first_name"
                      disabled="disabled"
                    />
                    <StandardErrorMessage formik={formik} name={"first_name"}/>
                   
                  </div>
                  <div className="form-group col-sm-6">
                    <LabelMedium>Second Name as per Your Official ID</LabelMedium>
                    <input
                      type="text"
                      className={
                        "form-control " +
                        (formik.touched.second_name && formik.errors.second_name
                          ? " is-invalid"
                          : "")
                      }
                      placeholder="Second Name"
                      value={formik.values.second_name}
                      onBlur={formik.handleBlur}
                      name="second_name"
                      disabled="disabled"
                    />
                    <StandardErrorMessage formik={formik} name={"second_name"}/>
                  </div>
                  <div className="form-group col-sm-6">
                    <LabelMedium>Third Name as per Your Official ID</LabelMedium>
                    <input
                      type="text"
                      className={
                        "form-control " +
                        (formik.touched.third_name && formik.errors.third_name
                          ? "is-invalid"
                          : null)
                      }
                      placeholder="Third Name"
                      name="third_name"
                      value={formik.values.third_name}
                      onBlur={formik.handleBlur}
                      disabled="disabled"
                    />
                    <StandardErrorMessage formik={formik} name={"third_name"}/>
                  </div>

                  <div className="form-group col-sm-6">
                    <LabelMedium>Student Type*</LabelMedium>
                    <select
                      className={
                        "form-control " +
                        (formik.touched.student_type &&
                        formik.errors.student_type
                          ? " is-invalid"
                          : "")
                      }
                      value={formik.values.student_type}
                      name="student_type"
                      onBlur={formik.handleBlur}
                      disabled="disabled"
                    >
                      <option value="">-------</option>
                      <option value="south-african-citizen">
                        South African Citizen
                      </option>
                      <option value="international-student">
                        International Student
                      </option>
                    </select>
                 
                    <StandardErrorMessage formik={formik} name={"student_type"}/>
                  </div>
                  {formik.values.student_type === "south-african-citizen" ? (
                    <div className="form-group col-sm-6">
                      <LabelMedium>RSA ID Number</LabelMedium>
                      <input
                        type="text"
                        className={
                          "form-control " +
                          (formik.touched.rsa_identity &&
                          formik.errors.rsa_identity
                            ? " is-invalid"
                            : "")
                        }
                        placeholder=""
                        value={formik.values.rsa_identity}
                        name="rsa_identity"
                        onBlur={formik.handleBlur}
                        disabled="disabled"
                      />
                      <StandardErrorMessage formik={formik} name={"rsa_identity"}/>
                    </div>
                  ) : null}

                  {formik.values.student_type === "international-student" ? (
                    <div className="form-group col-sm-6">
                      <LabelMedium>Passport Number</LabelMedium>
                      <input
                        type="text"
                        className={
                          "form-control " +
                          (formik.touched.rsa_identity &&
                          formik.errors.rsa_identity
                            ? " is-invalid"
                            : "")
                        }
                        placeholder=""
                        name="rsa_identity"
                        value={formik.values.rsa_identity}
                        onBlur={formik.handleBlur}
                        disabled="disabled"
                      />
                      <StandardErrorMessage formik={formik} name={"rsa_identity"}/>
                    </div>
                  ) : null}
                  {examId === true ? (
                    <>
                      <div className="form-group col-sm-6 d-flex align-items-center">
                        <div className="custom-control custom-checkbox text-left">
                          <input
                            type="checkbox"
                            className={
                              "custom-control-input " +
                              (formik.touched.is_exam_id && formik.errors.is_exam_id
                                ? " is-invalid"
                                : "")
                            }
                            name="is_exam_id"
                            onBlur={formik.handleBlur}
                            checked={formik.values.is_exam_id}
                            id="customCheck2"
                            disabled
                          />
                          <LabelMedium
                            className="custom-control-label"
                            htmlFor="customCheck2"
                          >
                            I do not have an Exam ID.
                          </LabelMedium>
                          <StandardErrorMessage formik={formik} name={"is_exam_id"}/>
                        </div>
                      </div>
                      <div className="form-group col-sm-6">
                        <LabelMedium>Exam ID Number (from previous exams)</LabelMedium>
                        <input
                          type="text"
                          value={formik.values.exam_id_number}
                          className={
                            "form-control " +
                            (formik.touched.exam_id_number &&
                            formik.errors.exam_id_number
                              ? " is-invalid"
                              : "")
                          }
                          placeholder=""
                          name="exam_id_number"
                          onBlur={formik.handleBlur}
                          disabled="disabled"
                        />
                        <StandardErrorMessage formik={formik} name={"rsa_identity"}/>
                        <div className="helper-text">
                          Previous 13 digit exam ID assigned to you by the DHET.
                        </div>
                      </div>
                    </>
                  ) : null}

                  <div className="form-group col-sm-6">
                    <LabelMedium>Gender*</LabelMedium>
                    <select
                      className={
                        "form-control " +
                        (formik.touched.gender && formik.errors.gender
                          ? " is-invalid"
                          : "")
                      }
                      name="gender"
                      value={formik.values.gender}
                      onBlur={formik.handleBlur}
                      disabled="disabled"
                    >
                      <option value="">-------</option>
                      <option value="male">Male</option>
                      <option value="female">Female</option>
                    </select>
                    <StandardErrorMessage formik={formik} name={"gender"}/>
                  </div>
                  <div className="form-group col-sm-6">
                    <LabelMedium>Race*</LabelMedium>
                    <select
                      className={
                        "form-control " +
                        (formik.touched.race && formik.errors.race
                          ? " is-invalid"
                          : "")
                      }
                      name="race"
                      value={formik.values.race}
                      onBlur={formik.handleBlur}
                      disabled="disabled"
                    >
                      <option value="">-------</option>
                      <option value="asian">Asian</option>
                      <option value="african">African</option>
                      <option value="coloured">Coloured</option>
                      <option value="indian">Indian</option>
                      <option value="white">White</option>
                      <option value="other">Other</option>
                    </select>
                    <StandardErrorMessage formik={formik} name={"race"}/>
                  </div>
                  <StudentDateBirthReadOnly
                    bday_day={user.bday_day}
                    bday_month={user.bday_month}
                    bday_year={user.bday_year}
                    formik={formik}
                  />
                  <div className="form-group col-12">
                    <LabelMedium>Detailed description and instructions:</LabelMedium>
                  </div>
                  <ExamSubjectAppendReadOnly formik={formik} examId={examid} />
                </div>
              </div>

              <ExamCentersReadOnly
                formik={formik}
                examCenterId={examCenterId}
                examStudentReg={examStudentReg}
                examdetails={examListsRow}
              />

              <div className="terms-condition-wrap">
                <Heading5>Terms & Conditions</Heading5>
                <p>
                  By submitting this examination registration, I hereby declare
                  that I have read through all the information on the Exam Info
                  page and I accept the rules and regulations as set out by the
                  Academic Institute of Excellence, in accordance with
                  requirements from the DHET, regarding qualifying for
                  eligibility to enter the external exams. I also confirm that
                  the details provided by me are correct.
                </p>
                <div className="custom-control custom-checkbox text-left">
                  <input
                    type="checkbox"
                    className={
                      "custom-control-input " +
                      (formik.touched.term_condn && formik.errors.term_condn
                        ? " is-invalid"
                        : "")
                    }
                    value={formik.values.term_condn}
                    name="term_condn"
                    checked="true"
                    onBlur={formik.handleBlur}
                  />
                  <StandardErrorMessage formik={formik} name={"term_condn"}/>

                  <LabelMedium
                    className="custom-control-label"
                    htmlFor="customCheck1"
                  >
                    I agree to the terms and conditions.
                  </LabelMedium>
                </div>
              </div>


              <StandardButton
                disabled="disabled"
                type="submit"
                variant="primary"
              >
                Submitted Application
              </StandardButton>
            </ContainerWrapper>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ExamRightBox;
